var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.37533 14.8542L10.0003 13.2708L12.6253 14.875L11.9378 11.875L14.2503 9.875L11.2087 9.60417L10.0003 6.77083L8.79199 9.58333L5.75033 9.85417L8.06283 11.875L7.37533 14.8542ZM4.85449 18.3333L6.20866 12.4792L1.66699 8.54167L7.66699 8.02083L10.0003 2.5L12.3337 8.02083L18.3337 8.54167L13.792 12.4792L15.1462 18.3333L10.0003 15.2292L4.85449 18.3333Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.4f4556d52114ac3434133355a6538c21.svg";
export { ForwardRef as ReactComponent };